import { render, staticRenderFns } from "./ChallengeSummary.vue?vue&type=template&id=31cf3ab5"
import script from "./ChallengeSummary.vue?vue&type=script&lang=js"
export * from "./ChallengeSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports